import React from 'react';
import './styles.css';
import {
    filosofia,
    mision,
    objetivos,
    usbg,
    valores,
    vision
} from './aboutUs/imagenesAboutUs'



export default function CualidadesEmpresa(props){


    return(<>
    <div className='contenedorCaracteristicasEmpresa'>
        <div className='gridContainerCaracteristicasEmpresa'>
            {/* <img src={mision}/> */}
            <div className="texto">
                <hr className='adorno'/>
                <h1>NOSOTROS</h1>

                {/* <img className='imagenHidden' src={mision}/> */}
                <p>
                Somos T&T Software de México, una empresa que se preocupa por ofrecer servicios
                de calidad con profesionales experimentados y capacitados para dar soluciones
                concretas y eficientes con el objetivo de Optimizar y Automatizar los procesos
                administrativos de las empresas.
                </p>
                <hr className='adornoHidden'/>
            </div>
        </div>
        <div className='gridContainerCaracteristicasEmpresa'>
            {/* <img src={mision}/> */}
            <div className="texto">
                <hr className='adorno'/>
                <h1>MISIÓN</h1>

                {/* <img className='imagenHidden' src={mision}/> */}
                <p>
                Nos comprometemos a desarrollar soluciones innovadoras de Tecnología de
                Información que mantengan confiabilidad y credibilidad con el objetivo de
                situarse como una empresa competitiva y consolidarse en el ámbito nacional e internacional.
                </p>
                <hr className='adornoHidden'/>
            </div>
        </div>

        <div className='gridContainerCaracteristicasEmpresa'>
            <div className="texto">
                <hr className='adorno'/>
                <h1>VISIÓN</h1>
               {/*  <img className='imagenHidden' src={vision}/> */}
                <p>
                Quienes integran T&T Software de México han comprendido la importancia de
                una continua superación de sus cuadros profesionales y técnicos, de ahí el
                afán de sostener un sistema de educación permanente en todos los campos de
                las especializaciones, ello es lo que nos permite ensanchar nuestro horizonte y
                ofrecer cada día mejores servicios
                </p>
                <hr className='adornoHidden'/>
            </div>
            <div></div>
            {/* <img src={vision}/> */}

        </div>

        

       


        

    </div>
    </>)
}